// Generated, DO NOT EDIT MANUALLY.
import _styles from "#pplx/frontend/composer-sdk/ComposerContainer.module.css";

export const styles = _styles;
